import { merge } from "lodash";

function getEnv() {
  if (location.hostname.includes("localhost")) {
    return "localdev";
  } else if (location.hostname.includes("192")) {
    return "localdev";
  } else if (location.hostname.includes("development")) {
    return "development";
  } else if (location.hostname.includes("production")) {
    return "production";
  } else {
    return "production";
  }
}
function parseConfig(env) {
  const cfgBase = require("./config.base.json");
  const cfg = require("./config." + env + ".json");
  return merge(cfgBase, cfg);
}

function setup() {
  return parseConfig(getEnv());
}

export default setup();



// WEBPACK FOOTER //
// ./src/lib/config/index.js